import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';

const SeverityPillRoot = styled('span')(({ theme, ownerState }) => {
  const paletteColor = theme.palette[ownerState.color] || theme.palette.primary;
  const backgroundColor = paletteColor.alpha12
    ?? alpha(paletteColor.main, theme.palette.mode === 'dark' ? 0.24 : 0.12);
  const color = theme.palette.mode === 'dark'
    ? paletteColor.main
    : (paletteColor.dark || paletteColor.main);

  return {
    alignItems: 'center',
    backgroundColor,
    borderRadius: 12,
    color,
    cursor: 'default',
    display: 'inline-flex',
    flexGrow: 0,
    flexShrink: 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 2,
    fontWeight: 600,
    justifyContent: 'center',
    letterSpacing: 0.5,
    minWidth: 20,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
  };
});

export const SeverityPill = (props) => {
  const { color = 'primary', children, ...other } = props;
  const safeColor = [
    'primary',
    'secondary',
    'error',
    'info',
    'warning',
    'success'
  ].includes(color)
    ? color
    : 'primary';

  const ownerState = { color: safeColor };

  return (
    <SeverityPillRoot
      ownerState={ownerState}
      {...other}>
      {children}
    </SeverityPillRoot>
  );
};

SeverityPill.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string
};
